export default {
  dbName: 'growth',
  maxWidth: 1000,
  site: {
    title: 'Растём при ДЦП с 2 до 20 лет' // Growth with cerebral palsy
  },
  graphs: {
    getData: (sex, disability, type) => {
      return import('~/../data/' + [sex, disability, type].join('-') + '.json')
    },
    common: {
      xMin: 2,
      xMax: 20,
      gridColor: '#aaaaaa',
      gridMainColor: '#333333',
      defaultLineOptions: {
        label: '',
        pointHitRadius: 2,
        pointRadius: 4,
        pointHoverRadius: 3,
        pointBorderWidth: 2,
        fill: false,
        showLine: true,
        lineTension: 0.4,
        borderWidth: 2,
        borderCapStyle: 'round',
        borderJoinStyle: 'round'
      },
      defaultGridOptions: {
        display: true,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true
      },
      debugGridOptions: {
        display: true,
        drawBorder: false,
        drawOnChartArea: false,
        drawTicks: true
      },
      defaultTicksOptions: {
        backdropColor: 'black',
        backdropPadding: 0
      }
    },
    weight: {
      color: '#FF0000',
      lineColor: '#FF0000',
      yMin: 1,
      yMax: 108.7
      /*
      lowBounds: {
        male: {
          3: [7.5, 8.9, 9.9, 11, 12.5, 13.8, 15, 16, 17, 18.1, 19.3, 20.9, 22.3, 23.8, 25.5, 27, 28.3, 29.5, 30.8]
        }
      },
      highBounds: {
        male: {
          3: [14.6, 17, 19, 21.2, 24.8, 28.8, 33, 37.5, 42, 47, 52, 56.8, 61.8, 66.2, 70, 73, 75.5, 77.4, 79]
        }
      }
      */
    },
    stature: {
      color: '#FF0000',
      lineColor: '#FF0000',
      yMin: 51,
      yMax: 203
    },
    bmi: {
      color: '#FF0000',
      lineColor: '#FF0000',
      yMin: 8,
      yMax: 37
    }
  }
}
